import React, {Component} from 'react'
import {Wrapper} from './components/Styled'
import PropTypes from 'prop-types'

class Accordion extends Component {
  static defaultProps = {
    content: '',
    title: ''
  }

  static propTypes = {
    content: PropTypes.string,
    customButtons: PropTypes.object,
    title: PropTypes.string
  }

  constructor (props) {
    super(props)
    this.content = React.createRef()
    this.state = {
      setActive: false,
      setHeight: '0px'
    }
  }

  toggleAccordion () {
    if (!this.state.setActive) {
      this.setState({setActive: !this.state.setActive})
      this.setState({setHeight: `${this.content.current.scrollHeight}px`})
    } else {
      this.setState({setHeight: '0px'})
      this.setState({setActive: !this.state.setActive})
    }
  }

  customButtons () {
    const {customButtons} = this.props
    if (customButtons) {
      return <span className='icon' > { this.state.setActive ? <img src={customButtons.minus}/> : <img src={customButtons.plus} /> } </span>
    }
    return <span className='icon' > { this.state.setActive ? '-' : '+' } </span>
  }

  render () {
    return (
      <Wrapper>
        <div className='accordion__section' onClick={() => this.toggleAccordion()} >
          <a className={`accordion ${this.state.setActive}`} >
            <span className='accordion__title' dangerouslySetInnerHTML={{__html: this.props.title}}></span>
            {this.customButtons()}
          </a>
          <div ref={this.content} className='accordion__content' style={{maxHeight: `${this.state.setHeight}`}}>
            <div className='accordion__text' dangerouslySetInnerHTML={{__html: this.props.content}}/>
          </div>
        </div>
      </Wrapper>
    )
  }
}

export default Accordion
